<template>
    <UiModal
        :is-open="open"
        @close="close()"
        :title="modalTitle"
        :is-teleported="true"
        :icon="'trash'"
        :icon-color="'red'"
    >
        <template #content>
            <div class="relative">
                <div class="space-y-4">
                    <p class="text-sm text-slate-500 mb-2">
                        Are you sure you want to delete
                        {{ business.name ? business.name : 'this business' }}?
                        This action cannot be undone.
                    </p>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex items-center justify-end gap-2">
                <button
                    type="button"
                    class="btn btn-secondary"
                    @click="close()"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="btn btn-danger"
                    @click="handleDelete()"
                >
                    Delete business
                </button>
            </div>
        </template>
    </UiModal>
</template>
<script setup>
import { ref } from 'vue';
import UiModal from '@/components/ui/modal/ui-modal.vue';
import { notify } from 'notiwind';

const props = defineProps({
    open: {
        type: Boolean,
        default: false,
    },
    business: {
        type: Object,
        default: () => ({}),
    },
});

const emit = defineEmits(['close', 'delete-business']);

const modalTitle = ref('Delete business entity');

const close = () => {
    emit('close');
};

const handleDelete = () => {
    emit('delete-business', props.business);
};
</script>
